import { render } from "./Companyprice.vue?vue&type=template&id=661c3aa8&scoped=true"
import script from "./Companyprice.vue?vue&type=script&lang=js"
export * from "./Companyprice.vue?vue&type=script&lang=js"

import "./Companyprice.vue?vue&type=style&index=0&id=661c3aa8&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661c3aa8"]])

export default __exports__